import { render, staticRenderFns } from "./CadasContratos.vue?vue&type=template&id=0f019f51&scoped=true"
import script from "./CadasContratos.vue?vue&type=script&lang=js"
export * from "./CadasContratos.vue?vue&type=script&lang=js"
import style0 from "./CadasContratos.vue?vue&type=style&index=0&id=0f019f51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f019f51",
  null
  
)

export default component.exports